import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../Hooks';
import { useParams } from 'react-router-dom';
import { IArticle } from '../types/api/homeApi';
import { getArticles } from '../features/blog';
import { Banner } from '../components/common/Banner';
import { Container } from 'react-bootstrap';
import { formatDateToDDMMYYYY } from '../../src/utils/hepler';
import { useTranslation } from 'react-i18next';
import { ISubBlog } from '../types/features/multiLanguageSlice';


const BlogDetails: React.FC<{ banner_title: string }> = ({ banner_title }) => {
  const dispatch = useAppDispatch();

  const {t} = useTranslation()
  const blog_json = t('blog.blogs', { returnObjects: true })  as ISubBlog[];

  const { id } = useParams<{ id: string }>();
  const [article, setArticle] = useState<IArticle | undefined>();
  const { articles } = useAppSelector((state) => state.blog);
  useEffect(() => {
    if (articles && articles.length <= 0) {
      dispatch(getArticles());
    }
  }, [dispatch,articles])

  useEffect(() => {
    if (articles && articles.length > 0) {
      const temp = articles.find((art) => art.slug === id);
      setArticle(temp);
    }
  }, [articles, id]);

  if (!article) {
    return <div className="spinner">
      <div className="simple-spinner"></div>
    </div>;
  }

  return (
    <>
      <Banner banner_title={banner_title}></Banner>
      <section className="blog-details">
        <Container>
          <div className='blogdetails-content'>
            <h3 className="title">{article.title}</h3>
            <ul className='blogdetails-info'>
              <li>
                <i className="fa fa-calendar" aria-hidden="true"></i>
                {formatDateToDDMMYYYY(article.updated_at)}
              </li>
              <li>
                <i className="fa fa-map-marker" aria-hidden="true"></i>{article.location_name}
              </li>
            </ul>
            {article.thumbnail_img && (
              <div className='blog-main-img'>
                <img
                  src={article.thumbnail_img}
                  alt={article.title}
                  className=" img-fluid"
                />
              </div>
            )}
            <div
              className="blog-description"
              dangerouslySetInnerHTML={{ __html: article.description }}
            ></div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default BlogDetails;
